var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcArbitrum24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24.003,
    viewBox: "0 0 24 24.003",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.639 14.9a12 12 0 1 1 -8.739-14.54 12 12 0 0 1 8.739 14.54z",
    fill: "#2d374b",
    transform: "translate(0 .001)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m60.186 52.93 1.5-2.539 4.033 6.281v1.205l-.019-8.293a.625.625 0 0 0 -.289-.5l-7.26-4.176a.64.64 0 0 0 -.555 0 .6.6 0 0 0 -.065.038l-.025.016-7.044 4.088-.027.012a.637.637 0 0 0 -.1.061.627.627 0 0 0 -.26.47l.011 6.759 3.756-5.822a2.754 2.754 0 0 1 2.46-1.007l1.123.03-6.619 10.607.78.449 6.694-11.046 2.959-.011-6.677 11.325 2.782 1.6.332.191a.638.638 0 0 0 .448.009l7.362-4.266-1.408.816zm.571 8.221-2.81-4.41 1.715-2.911 3.691 5.817z",
    fill: "#2d374b",
    transform: "translate(-45.891 -41.78)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m237.768 261.826 2.81 4.41 2.6-1.5-3.691-5.817z",
    fill: "#28a0f0",
    transform: "translate(-225.712 -246.865)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m296.665 184.454v-1.205l-4.033-6.281-1.5 2.539 3.893 6.3 1.408-.816a.624.624 0 0 0 .23-.454z",
    fill: "#28a0f0",
    transform: "translate(-276.839 -168.356)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m20.219 165.738 1.988 1.145 6.614-10.608-1.123-.03a2.754 2.754 0 0 0 -2.46 1.007l-3.756 5.822-1.264 1.942z",
    fill: "#fff",
    transform: "translate(-17.292 -148.504)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m95.822 156.964-2.959.011-6.693 11.046 2.34 1.347.636-1.079z",
    fill: "#fff",
    transform: "translate(-80.476 -149.192)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m38.363 20.958a1.885 1.885 0 0 0 -.885-1.515l-7.355-4.23a1.913 1.913 0 0 0 -1.688 0c-.061.031-7.153 4.144-7.153 4.144a1.882 1.882 0 0 0 -1.065 1.6v8.76l1.264-1.942-.011-6.759a.6.6 0 0 1 .009-.073.622.622 0 0 1 .251-.4c.033-.024 7.246-4.2 7.269-4.21a.64.64 0 0 1 .555 0l7.26 4.176a.625.625 0 0 1 .289.5v8.373a.61.61 0 0 1 -.217.454l-1.408.816-.726.421-2.6 1.5-2.628 1.527a.638.638 0 0 1 -.448-.009l-3.115-1.791-.636 1.079 2.8 1.612.243.137c.1.059.176.1.2.11a1.818 1.818 0 0 0 .743.153 1.871 1.871 0 0 0 .689-.131l7.646-4.428a1.87 1.87 0 0 0 .72-1.408z",
    fill: "#96bedc",
    transform: "translate(-17.291 -13.201)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArbitrum24);
export default __webpack_public_path__ + "static/media/ic_arbitrum_24.21ec7bfe3217eb0c5f88328a73b8ebf6.svg";
export { ForwardRef as ReactComponent };